import type { IUserDetailsEntity } from '@intigral/domain';

/** Fallback tier/subscription when the guest login API omits them. */
export const GUEST_SUBSCRIPTION_DEFAULTS: Pick<
    IUserDetailsEntity,
    'tierStatus' | 'subscriptionStatus' | 'subscriptionRev' | 'tierConfig' | 'identityToken'
> = {
    identityToken: '',
    subscriptionRev: 1,
    tierStatus: {
        contractId: -1,
        serviceId: -1,
        nextRenewalDate: 0,
        subscriptionDate: 0,
        lastUpdated: 0,
        amount: '0.0',
        statusName: 'ACTIVE',
        active: true,
        billingCycle: 0,
        tierGuid: 'LITE_TIER',
        subscriptionGuid: 'BASE_SUBSCRIPTION',
        graceInfo: null,
    },
    subscriptionStatus: [
        {
            contractId: -1,
            serviceId: -1,
            nextRenewalDate: 0,
            subscriptionDate: 1590065714000,
            lastUpdated: 0,
            amount: '0.0',
            statusName: 'ACTIVE',
            currency: 'SAR',
            subscriptionGuid: 'BASE_SUBSCRIPTION',
            active: true,
            billingCycle: 0,
            subPackageType: 'ALACARTE_FREE',
            graceInfo: null,
        },
        {
            contractId: -1,
            serviceId: -1,
            nextRenewalDate: 0,
            subscriptionDate: 1590065714000,
            lastUpdated: 0,
            amount: '0.0',
            statusName: 'ACTIVE',
            currency: 'SAR',
            subscriptionGuid: 'DISCOVERY_PLUS_SUBSCRIPTION',
            active: true,
            billingCycle: 0,
            subPackageType: 'ALACARTE_FREE',
            graceInfo: null,
        },
    ],
    tierConfig: {
        tierName: 'Lite',
        tierGuid: 'LITE_TIER',
        tierRank: 1,
        audioQuality: 'Stereo (2.1)',
        linearVideoQuality: 'HQ',
        vodVideoQuality: 'HQ',
        casting: false,
        price: '11.5',
        deviceAccess: 'all',
        priceCurrency: 'SAR',
        freeTrialDuration: 7,
        rewindDuration: 1,
        rewindDurationUnit: 'days',
        epgNextDays: 2,
        epgPreviousDays: 1,
        freeTrialDurationUnit: 'days',
        streamConcurrencyConfig: {
            streamConcurrencyEnabled: true,
            lockQuota: 2,
        },
        downloadConfig: {
            deviceLimit: 4,
            maxDownloadPerUser: 10,
            downloadEnabled: false,
        },
        devicesConfig: {
            deviceLimit: 6,
        },
    },
};
